import { useDataSubmit } from 'Simple/Data.js'

export function useOnClickCancel(props) {
  let submit = useDataSubmit({
    context: 'tags_picker',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'cancel_edit_tag',
    })
  }
}

export function useOnClickSave(props) {
  let submit = useDataSubmit({
    context: 'tags_picker',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'save_edit_tag',
    })
  }
}
